import { cn } from '@/lib/cn';

/**
 * Lambang Crawel - logo asli dari rancangan, bukan gambar ulang.
 *
 * Berkasnya diambil langsung dari PDF rancangan lalu dibuat transparan, dan
 * dipasang lewat CSS mask alih-alih `<img>`. Bedanya penting: dengan mask,
 * bentuk logo diambil dari berkas sementara **warnanya berasal dari
 * `currentColor`** - jadi satu berkas yang sama tampil putih di sidebar gelap
 * dan navy di halaman terang, persis seperti SVG, tanpa perlu dua versi.
 *
 * Rasio aslinya 1,286 (756×588); `aspect-ratio` menjaganya tetap benar di
 * ukuran berapa pun.
 */
const MASK_STYLE = {
  WebkitMaskImage: 'url(/logo-mask.png)',
  maskImage: 'url(/logo-mask.png)',
  WebkitMaskSize: 'contain',
  maskSize: 'contain',
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  maskPosition: 'center',
  aspectRatio: '756 / 588',
};

export const LogoMark = ({ className }) => (
  <span
    className={cn('inline-block h-6 bg-current', className)}
    style={MASK_STYLE}
    aria-hidden="true"
  />
);

export const Logo = ({ variant = 'dark', className, showText = true, markClassName }) => (
  <span
    className={cn(
      'inline-flex items-center gap-2.5 font-extrabold tracking-tight',
      variant === 'light' ? 'text-white' : 'text-[var(--text-primary)]',
      className,
    )}
  >
    <LogoMark className={markClassName} />
    {showText && <span className="text-[17px]">Crawel</span>}
  </span>
);
